import { Component } from "react";
import View from "./view";
import { withRouter } from "react-router-dom";
import qs from "qs";

class Scanner extends Component {
  constructor(props) {
    super(props);
    const { url } = qs.parse(props.location.search.slice(1));
    this.state = {
      url,
      detected: false
    };
  }

  render() {
    return View.call(this);
  }
}

export default withRouter(Scanner);



// WEBPACK FOOTER //
// ./src/screens/scanner/index.js